// extracted by mini-css-extract-plugin
module.exports = {"rentalInfoWrapper":"fT","status":"fU","timeLeft":"fV"};